(() => {
  const page = document.querySelector('.releases-page');
  if (!page) return;
  let cards = [...page.querySelectorAll('.release-card')];
  const filters = [...page.querySelectorAll('[data-release-filter]')];
  const search = page.querySelector('input[type="search"]');
  const count = page.querySelector('.releases-result-count');
  const empty = page.querySelector('.releases-no-results');
  let active = 'all';
  function update() {
    const query = search.value.trim().toLocaleLowerCase();
    let visible = 0;
    cards.forEach(card => {
      const tags = card.dataset.releaseTags.split(' ');
      const text = `${card.querySelector('.release-card-title').textContent} ${card.querySelector('.card-set').textContent}`.toLocaleLowerCase();
      card.hidden = !(active === 'all' || tags.includes(active)) || !text.includes(query);
      if (!card.hidden) visible++;
    });
    count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
    empty.hidden = visible !== 0 || cards.length === 0;
  }
  filters.forEach(button => button.addEventListener('click', () => {
    active = button.dataset.releaseFilter;
    filters.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
    update();
  }));
  search.addEventListener('input', update);
  page.querySelector('.releases-toolbar').hidden = false;
  count.hidden = false;
  update();

  // Server-rendered release cards are already available on arrival. Refresh their
  // badges as well as the shared product data without resetting search or filters.
  let refreshing = false;
  document.addEventListener('catalog:refreshed', async () => {
    if (refreshing) return;
    refreshing = true;
    try {
      const response = await fetch(location.href, { cache: 'no-store', signal: AbortSignal.timeout(20000) });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshGrid = doc.querySelector('.releases-grid');
      if (!freshGrid) return;
      page.querySelector('.releases-grid').replaceChildren(...freshGrid.childNodes);
      cards = [...page.querySelectorAll('.release-card')];
      update();
    } catch (_) { /* Keep the current lineup when the refresh is unavailable. */ }
    finally { refreshing = false; }
  });
})();
